module.exports = __webpack_public_path__ + "static/img/bg15.a70b4f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg15.jpg
// module id = sPjB
// module chunks = 1